import { render, staticRenderFns } from "./StudentDocuments.vue?vue&type=template&id=2c17553c&"
import script from "./StudentDocuments.vue?vue&type=script&lang=js&"
export * from "./StudentDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports